import React, { CSSProperties, useState } from "react";
import { axiosInstance } from "../../../../utils";
import shellLogo from "../../assets/images/clean-img/shell-logo.svg";
import { Divider } from "@mui/material";
import { AxiosError } from "axios";
import { enqueueSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";

export default function TTSForm() {
  const navigate = useNavigate();
  const [kvkk, setKvkk] = useState(true);
  const [disabled, setDisabled] = useState(false);
  const [form, setForm] = useState<any>({
    name: "",
    phone: "",
    company_name: "",
    vehicle_quantity: "",
    products: [],
  });

  /** <label className="checkbox" style={labelStyle}>
                <input
                  type="checkbox"
                  name="RequestForm.ProductType"
                  data-id="Pratik_Kart"
                  value="Pratik_Kart"
                />
                <span className="Text">Pratik Kart</span>
              </label> */

  const productsArray = [
    {
      name: "tts",
      dataId: "tts",
      title: "Taşıt Tanıma Sistemi",
    },
    {
      name: "pratikKart",
      dataId: "pratikKart",
      title: "Pratik Kart",
    },
    {
      name: "partnerCard",
      dataId: "partnerCard",
      title: "Partner Card",
    },
    {
      name: "hgs",
      dataId: "hgs",
      title: "Hızlı Geçiş Sistemi",
    },
  ];
  const labelStyle: CSSProperties = {
    marginRight: "20px",
  };

  const logoStyle: CSSProperties = {
    maxWidth: "180px",
    width: "45%",
    height: "auto",
    display: "block",
    margin: "0 auto 12px",
  };

  const buttonStyle: CSSProperties = {
    backgroundColor: disabled ? "#808080" : "#ed6c02",
    color: disabled ? "#ffffff" : "#ffffff",
    cursor: disabled ? "not-allowed" : "pointer",
    opacity: disabled ? 0.7 : 1,
  };

  const handleSubmit = async () => {
    try {
      if (!kvkk) {
        enqueueSnackbar(
          "Devam etmek için KVKK metnini kabul etmeniz gerekmektedir.",
          { variant: "error" }
        );
        return;
      }
      setDisabled(true);

      const response = await axiosInstance.post("/ttsform/create", form);

      if (response.status === 201) {
        const uuid = uuidv4();
        navigate("/tts-basvuru-basarili", { state: { uuid } });
        return;
      }
    } catch (e) {
      if (e instanceof AxiosError && e.response?.status === 400) {
        const errors = e.response?.data.errors;
        if (errors) {
          (errors as any[]).map((error) => {
            enqueueSnackbar(error, { variant: "error" });
          });
        }
      }
      if (e instanceof AxiosError && e.response?.status === 500) {
        enqueueSnackbar("Bir hata oluştu.", { variant: "error" });
      }
    } finally {
      setDisabled(false);
    }
  };

  return (
    <>
      <div className="row center-xs">
        <div className="col-lg-12 col-xs textRow">
          <img src={shellLogo} style={logoStyle} alt="Shell Logo" />
          <h2 className="title">
            Shell Taşıt Tanıma Sistemi
            <br />
            <span className="red big">İNDİRİM HESAPLAMA FORMU</span>
          </h2>
          <div className="textCapsule">
            <p>
              Bilgilerinizi ve araç adedinizi girerek, firmanız için özel olarak
              hesaplanan akaryakıt indirim oranınızı öğrenebilirsiniz.
            </p>
          </div>
        </div>
      </div>
      <div className="row mt-1 center-xs">
        <div className="col-sm-10 col-xs">
          <div className="forms" id="form-post-application">
            <ul className="row">
              <li className="col-sm-6 col-xm-6 col-xs-12">
                <input
                  type="text"
                  name="name"
                  id="name"
                  placeholder="Adınız Soyadınız *"
                  value={form.name}
                  required
                  onChange={(e) =>
                    setForm((prev: any) => ({
                      ...prev,
                      name: e.target.value,
                    }))
                  }
                />
              </li>
              <li className="col-sm-6 col-xm-6 col-xs-12">
                <input
                  type="text"
                  name="company_name"
                  id="company_name"
                  placeholder="Firma Adı *"
                  value={form.company_name}
                  required
                  onChange={(e) =>
                    setForm((prev: any) => ({
                      ...prev,
                      company_name: e.target.value,
                    }))
                  }
                />
              </li>
              {/* <li className="col-sm-6 col-xm-6 col-xs-12">
              <input
                type="number"
                name="RequestForm.CompanyIdentity"
                id="CompanyIdentity"
                placeholder="Vergi Numarası"
                required
              />
            </li> */}
              <li className="col-sm-6 col-xm-6 col-xs-12">
                <input
                  type="number"
                  name="phone"
                  id="phone"
                  placeholder="Telefonunuz *"
                  value={form.phone}
                  required
                  onChange={(e) =>
                    setForm((prev: any) => ({
                      ...prev,
                      phone: e.target.value,
                    }))
                  }
                />
              </li>
              <li className="col-sm-6 col-xm-6 col-xs-12">
                <input
                  type="number"
                  name="vehicle_quantity"
                  id="vehicle_quantity"
                  placeholder="Araç Adedi *"
                  value={form.vehicle_quantity}
                  required
                  onChange={(e) =>
                    setForm((prev: any) => ({
                      ...prev,
                      vehicle_quantity: e.target.value,
                    }))
                  }
                />
              </li>
              <li className="col-xs-12 start-xs ">
                <span>
                  <p style={{ color: "black" }}>
                    Lütfen Talepte Bulunduğunuz Ürünleri Seçiniz.
                  </p>
                </span>
                <br />
                <div className="formCheckboxes">
                  {productsArray.map((prod, index) => (
                    <label key={index} className="checkbox" style={labelStyle}>
                      <span
                        className={`custom-checkbox ${
                          form.products?.includes(prod.name as string)
                            ? "selected"
                            : ""
                        }`}
                      >
                        <input
                          type="checkbox"
                          name={prod.name}
                          data-id={prod.dataId}
                          checked={form.products?.includes(prod.name as string)}
                          onChange={() => {
                            let arr: Array<string> = form.products;
                            const product = arr?.includes(prod.name as string);
                            if (!product) {
                              arr.push(prod.name as string);
                            } else {
                              arr = arr.filter(
                                (p) => p !== (prod.name as string)
                              );
                            }
                            setForm((prev: any) => ({
                              ...prev,
                              products: arr,
                            }));
                          }}
                        />
                      </span>
                      <span className="Text">{prod.title}</span>
                    </label>
                  ))}
                </div>
              </li>
              <Divider />

              <li className="col-xs-12 start-xs onay">
                <label className="checkbox">
                  <span className={`custom-checkbox ${kvkk ? "selected" : ""}`}>
                    <input
                      type="checkbox"
                      className="onay"
                      id="IsKvk"
                      name="RequestForm.IsKvk"
                      checked={kvkk}
                      onChange={() => setKvkk(!kvkk)}
                    />
                  </span>
                  <span className="Text">
                    <a href="/kvkk" target="_blank">
                      KVKK metnini
                    </a>{" "}
                    Okudum Kabul Ediyorum.
                  </span>
                </label>
              </li>
              <li className="col-xs-12">
                <button
                  className="form-submit-button"
                  disabled={disabled}
                  onClick={handleSubmit}
                  style={buttonStyle}
                >
                  İNDİRİM ORANINI ÖĞREN
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}
